import styled from 'styled-components';
import { CardTypes } from './Card';
import { theme } from '../../styles/theme';
const handleType = ($type) => {
    switch ($type) {
        case CardTypes.Subtle:
            return `background: ${theme.colors.backgroundLightest};`;
        case CardTypes.Inverted:
            return `background: ${theme.colors.backgroundBrand}; color: ${theme.colors.textInverted};`;
        default:
            return `background: ${theme.colors.backgroundPrimary};`;
    }
};
export const Wrapper = styled.div `
  background: ${theme.colors.backgroundPrimary};
  border: 1px solid ${theme.colors.borderDark};
  border-radius: ${theme.spacing.xs};
  height: 100%;
  padding: ${theme.spacing.md};
  position: relative;
  ${({ $type }) => handleType($type)};
  ${({ $showOverflow }) => ($showOverflow ? `` : `overflow: hidden;`)};

  @media only screen and (min-width: 600px) {
    padding: ${theme.spacing.lg};
  }
`;
export const Menu = styled.span `
  cursor: pointer;
  height: 42px;
  padding: 9px;
  position: absolute;
  right: 8px;
  top: 11px;
  width: 42px;

  @media only screen and (min-width: 600px) {
    right: ${theme.spacing.md};
    top: calc(${theme.spacing.md} + 3px);
  }
`;
